import CarDemo2Container from "../../components/home/carDemo2";

const CarDemo2 = () => {
  return <CarDemo2Container />;
};

export default CarDemo2;
